import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section, Eyebrow } from '../Section';
import { CTAButton } from '../CTAButton';
const included = ['Every document.', 'Every process.', 'Every checklist.', 'Every protocol.', 'Every professional form.'];
export function Presenting() {
  return <Section tone="light" data-id="element-204" data-mp="dhmrc9fdmbwa">
      <Eyebrow tone="light" data-id="element-205" data-mp="difocioj9n18">Presenting</Eyebrow>
      <h2 className="mt-2 text-center font-display text-[30px] font-extrabold uppercase leading-[1.03] text-navy-950 sm:text-[44px]" data-id="element-206" data-mp="1a6ubbd0ckcy3">
        🔧 Technical System PRO 360™
      </h2>
      <p className="mx-auto mt-3 max-w-2xl text-center text-[15px] leading-relaxed text-navy-800 sm:text-lg" data-id="element-207" data-mp="15adfrxqtiwaz">
        The complete operating system designed to help you turn your repair
        trade into an organized, profitable and professional business.
      </p>

      <div className="mt-6 flex justify-center" data-id="element-208" data-mp="1sz6bbt3j3252">
        <img src="https://cdn.magicpatterns.com/uploads/aMbBWv5rmcu4mMwStXQ2oo/SOLDADURA-IT.png" alt="Technical System PRO 360 complete system package" className="w-full max-w-[260px] drop-shadow-[0_18px_30px_rgba(10,21,38,0.25)] sm:max-w-[320px]" data-id="element-209" data-mp="1o751edtu1ni7" />
      </div>

      <div className="mt-6 rounded-2xl bg-navy-950 p-5 text-white sm:p-7" data-id="element-210" data-mp="2cpqzcw7uzi3u">
        <p className="text-[15px] leading-relaxed text-white/85 sm:text-lg" data-id="element-211" data-mp="2cnmsq6iks4zv">
          This is not another online course. It’s not just a collection of PDFs.
        </p>
        <p className="mt-3 text-[15px] leading-relaxed text-white/85 sm:text-lg" data-id="element-212" data-mp="23n7y2gjq1djp">
          It’s a complete system bringing together the documents, processes,
          checklists, protocols and tools you would normally spend months or
          even years creating on your own.
        </p>

        <ul className="mt-5 space-y-2" data-id="element-213" data-mp="1yq81cw8rhn59">
          {included.map(item => <li key={item} className="flex items-center gap-3" data-id="element-214" data-mp="3o5pbj8yc2k9a">
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gold-500" data-id="element-215" data-mp="3t3qrhl0gq3gj">
                <CheckIcon className="h-4 w-4 text-navy-950" aria-hidden="true" data-id="element-216" data-mp="3rmad8xtv3i2y" />
              </span>
              <span className="text-[15px] font-semibold sm:text-lg" data-id="element-217" data-mp="3mm5s2ui0dz6e">
                {item}
              </span>
            </li>)}
        </ul>

        <p className="mt-5 font-display text-[20px] font-bold uppercase leading-tight text-gold-500 sm:text-2xl" data-id="element-218" data-mp="3dnakbdzbgh0z">
          Already prepared for you. Download it, customize it and start using
          it.
        </p>
      </div>

      <div className="mt-8" data-id="element-219" data-mp="99vrbwjlmthj">
        <CTAButton label="I want my complete system" data-id="element-220" data-mp="9ani8u29431h" />
      </div>
    </Section>;
}